import gql from 'graphql-tag';
export const GetDeviceName = gql `
    query GetDeviceName {
        me {
            deviceInformation {
                deviceId
                name
            }
        }
    }
`;
export const GetUnlockEventsJWT = gql `
    query GetUnlockEventsJWT {
        doorLocking {
            subscribeToUnlockEvents
        }
    }
`;
